import { Controller } from "@hotwired/stimulus";
//import "tom-select/dist/css/tom-select.css";

export default class extends Controller {

  connect() {
    var options = {
      headers: { 
        0: {sorter:false, filter:false},
        1: {sorter:false, filter:false},
        2: {sorter:false, filter:false},
        3: {sorter:false, filter:false},
        4: {sorter:false, filter:false},
        5: {sorter:false, filter:false},
        6: {sorter:false, filter:false},
        7: {sorter:false, filter:false},
        8: {sorter:false, filter:false},
        9: {sorter:false, filter:false},
        10: {sorter:false, filter:false},
        11: {sorter:false, filter:false}
        }
    };
    bindTablesorter($(".portfolio-tablesorter"), options, {}, "");
    bindTablesorterPopover('');
    bindPopover();
    hideColumnSortSpinner();
  }
}
